import React, { FC } from 'react'

import { Icons } from '../Icon'

import * as SC from './styled'

export type FeedbackProps = {
  className?: string
  isOpen: boolean
  text: string
  onClose?: () => void
}

const Feedback: FC<FeedbackProps> = ({ className, isOpen, text, onClose }) => {
  return (
    <SC.Container className={className} $isVisible={isOpen}>
      <SC.Text>{text}</SC.Text>
      <SC.Close
        icon={Icons.close}
        variantType="button"
        variantIcon="only"
        actionProps={{
          onClick: onClose,
        }}
      />
    </SC.Container>
  )
}

export default Feedback
